import { Avatar, Box, Grid, Typography } from '@mui/material'
import React from 'react';

import {useResponsiveStyles} from '../../../utils/responsiveStyles';

const Users = ({customerDetailsData}) => {
    const styles = useResponsiveStyles();
  return (
    <Grid container spacing={2} sx={{p:'10px'}}>
        <Grid item xs={12} sx={{mt:'10px'}} />
        {customerDetailsData?.recruiterDetails.length > 0 ?
            customerDetailsData?.recruiterDetails.map((data) => 
        <Grid item xs={12} sx={{ p:'10px'}}>
            <Box sx={{display:'flex', gap:'10px', border: '1px solid #ddd', p:'10px'}}>
                <Avatar />
                <Box sx={{}}>
                <Typography paragraph variant='h6' sx={{m:0, fontWeight: 600}}>
                    {data?.recruiter_name}
                </Typography>
                <Typography paragraph sx={{m:0, fontWeight: 600, color:'#406882', fontSize: styles.fontSize14}}>
                    {data?.role}
                </Typography>
                <Typography paragraph sx={{m:0,}}>
                    {data?.recruiter_email}
                </Typography>
                </Box> 
            </Box>
        </Grid>
        )
        : <Grid item xs={12}>
            <Box sx={{textAlign: 'center', mt:'50px'}}>
                <Typography paragraph>
                    Users Not Found
                </Typography>
            </Box>

        </Grid>}
    </Grid>
  )
}

export default Users